<template>
  <div>
    <p style="padding-top:.4rem;line-height:.5rem">
      推荐课程：
    </p>
    <ul>
      <li
        v-for="(item, index) in courseList"
        :key="index"
        @click="goLive(item)"
      >
        <img :src="item.coverPicUrl" />
        <div class="courseName">
          {{ item.courseName }}
        </div>
        <div class="grey">
          <span>{{ item.userName }}</span>
          <span style="margin-left: .2rem">{{ item.duties }}</span>
        </div>
        <div class="grey">
          {{ item.hospitalName }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    courseList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    goLive(item) {
      this.$router.push({ name: 'courseDetail', params: { id: item.id } });
      // location.href = '/html/newWechat.html#/courseDetail/'+item.id
    }
  }
};
</script>

<style lang="less" scoped>
p {
  font-size: 0.43rem;
  color: #191919;
  font-weight: bold;
  margin-bottom: 0.32rem;
}
ul {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 1.6rem;
}
li:nth-of-type(odd) {
  margin-right: 0.13rem;
}
li {
  margin-bottom: 0.4rem;
  img {
    width: 4.53rem;
    height: 2.56rem;
    margin-bottom: 0.13rem;
  }
  .courseName {
    font-size: 0.37rem;
    color: #191919;
    line-height: 0.53rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 4.53rem;
  }
  .grey {
    font-size: 0.32rem;
    color: #999;
    line-height: 0.47rem;
    width: 4.53rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
